import { extend } from 'flarum/common/extend';
import SettingsPage from 'flarum/forum/components/SettingsPage';
import Switch from 'flarum/common/components/Switch';

app.initializers.add('eurofo-signature-toggle', () => {
  // Проверяем настройку при инициализации приложения после полной загрузки сессии
  setTimeout(() => {
    const user = app.session && app.session.user;
    if (user && user.preferences() && user.preferences().showSignatures === false) {
      document.body.classList.add('hide-user-signatures');
    }
  }, 0);

  // Добавляем переключатель на страницу настроек
  extend(SettingsPage.prototype, 'settingsItems', function(items) {
    items.add('signatureHeading', <h3>{app.translator.trans('eurofo-signature-toggle.forum.user.settings.signature_heading')}</h3>, 20);

    items.add('showSignatures', Switch.component({
      state: this.user.preferences().showSignatures,
      onchange: (value) => {
        this.showSignaturesLoading = true;
        this.user.savePreferences({ showSignatures: value }).then(() => {
          this.showSignaturesLoading = false;
          if (value) {
            document.body.classList.remove('hide-user-signatures');
          } else {
            document.body.classList.add('hide-user-signatures');
          }
          m.redraw();
        });
      },
      loading: this.showSignaturesLoading
    }, app.translator.trans('eurofo-signature-toggle.forum.user.settings.show_signatures_label')), 19);
  });
});
